import React from 'react';
import { Button } from '@material-ui/core';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logUserIn } from '../../redux/authReducer';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionExpired = searchParams.get('session') === 'expired';

  const validationSchema = yup.object({
    email: yup.string().email().required(),
    password: yup.string().required().min(6),
  });

  const submitLogInUser = (values) => {
    dispatch(logUserIn(values.email, values.password, navigate));
  };

  return (
    <div className="flex p-6 items-center justify-center text-2xl min-h-screen">
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={validationSchema}
        onSubmit={submitLogInUser}
      >
        <Form action="">
          <h1 className="text-3xl my-6 text-center">SafetyNet Login</h1>
          {sessionExpired && (
            <p className="text-sm text-center mb-4 text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2 max-w-md mx-auto">
              Your session expired. Sign in again to continue.
            </p>
          )}
          <p className="text-sm text-center mb-4 text-gray-600">
            Use the same email and password as the main ATO Platform.
          </p>
          <div>
            <Field
              type="email"
              name="email"
              id="Email"
              placeholder="Contact@atoplatform.com"
              className=" mt-4 p-2 w-full text-ato-form-text border-2 border-ato-form-border md:p-4 font-universLight text-xs md:text-base"
            />
            <ErrorMessage name="email">
              {(msg) => (
                <div className="text-sm md:text-md text-ato-red font-semibold">* {msg}</div>
              )}
            </ErrorMessage>
            <Field
              type="password"
              name="password"
              id="password"
              className=" mt-4 p-2 w-full text-ato-form-text border-2 border-ato-form-border md:p-4 font-universLight text-xs md:text-base"
            />
            <ErrorMessage name="password">
              {(msg) => (
                <div className="text-sm md:text-md text-ato-red font-semibold">* {msg}</div>
              )}
            </ErrorMessage>
          </div>
          <div className="mt-3 justify-center flex">
            <Button variant="contained" color="primary" type="submit">
              Login
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default Login;
